import { ColorPicker, ColorPickerProps } from 'components'

export const ColorPickerUtil = (props: ColorPickerProps) => (
  <ColorPicker {...props} />
)
